/**
 * This is the entry point for the game.
 */
import { Game } from './Game';
import { Workshop } from './Workshop';
import { TouchControls } from './TouchControls';
import { HighScoresUI } from './HighScoresUI';
import { ReplayUI } from './ReplayUI';

Workshop.init();
HighScoresUI.init();
ReplayUI.init(Workshop);
Game.init();
TouchControls.init();
